import { Component, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from '../../../store';
import { Router } from '@angular/router';
import { D60 } from '@store/models';

@Component({
    selector: 'app-60d',
    template: `
        <app-60d-ui
            [d60]="d60$ | async"
            (dismiss)="dismiss()"
            (openClient)="openClient($event)"
        ></app-60d-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class D60Container {

    d60$ = this.notificationsService.getD60();

    constructor(
        public activeModal: NgbActiveModal,
        private notificationsService: NotificationsService,
        private router: Router
    ) {}

    openClient(d60: D60) {
        this.router.navigate(['/clients', d60.kid]);
        this.activeModal.close();
    }

    dismiss() {
        this.activeModal.dismiss();
    }
}
